import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { TaskStatusService } from 'src/app/shared/services/task-status.service';
import { TaskStatus, getTaskStatusDescription } from 'src/app/shared/models/task-status.model';

@Component({
  selector: 'app-task-status-notification',
  templateUrl: './task-status-notification.component.html',
  styleUrls: ['./task-status-notification.component.scss'],
  providers: [TaskStatusService],
})
export class TaskStatusNotificationComponent implements OnInit {
  tasks$: Observable<TaskStatus[]>;
  pendingTasksCount$: Observable<number>;

  constructor(private taskStatusService: TaskStatusService) { }

  ngOnInit(): void {
    this.tasks$ = this.taskStatusService.noReadTasks$;
    this.pendingTasksCount$ = this.taskStatusService.pendingTasksCount$;
  }

  getStatusIcon(status: string): string {
    switch (status) {
      case 'PENDING': return 'cilClock';
      case 'PROCESSING': return 'cilSync';
      case 'COMPLETED': return 'cilCheckCircle';
      case 'COMPLETED_WITH_ERRORS': return 'cilBan';
      case 'FAILED': return 'cilXCircle';
      default: return 'cilTask';
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'PENDING': return 'text-warning';
      case 'PROCESSING': return 'text-info';
      case 'COMPLETED': return 'text-success';
      case 'COMPLETED_WITH_ERRORS': return 'text-secondary';
      case 'FAILED': return 'text-danger';
      default: return '';
    }
  }

  getStatusDesc(status: string): string {
    return getTaskStatusDescription(status);
  }

  markAllAsRead(): void {
    this.taskStatusService.markAllAsRead().subscribe(() => {
      this.taskStatusService.startPolling();
      this.taskStatusService.autoStopPolling = true;
    });
  }
}
